module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.db812d8a.woff2";